import { router } from '@inertiajs/react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Switch } from '@/components/ui/switch';
import type { SharedProps } from '@/types';

interface JobToggleProps {
  jobName: string;
  enabled: boolean;
  eventSlug?: string | null;
}

export function JobToggle({ jobName, enabled, eventSlug }: JobToggleProps) {
  const [isEnabled, setIsEnabled] = useState(enabled);
  const [isPending, setIsPending] = useState(false);

  const handleToggle = (checked: boolean) => {
    setIsEnabled(checked);
    setIsPending(true);

    router.post(
      `/admin/cron/jobs/${jobName}/toggle`,
      { enabled: checked, ...(eventSlug ? { event_slug: eventSlug } : {}) },
      {
        preserveScroll: true,
        onSuccess: (page) => {
          const { flash } = page.props as unknown as SharedProps;

          if (flash.alert) {
            setIsEnabled(!checked);
            toast.error(flash.alert);
          } else {
            toast.success(flash.notice ?? 'Job updated successfully');
          }
        },
        onError: () => {
          setIsEnabled(!checked);
          toast.error('Failed to toggle job');
        },
        onFinish: () => setIsPending(false),
      },
    );
  };

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={isEnabled}
        onCheckedChange={handleToggle}
        disabled={isPending}
      />
      <span className="text-muted-foreground text-sm">
        {isEnabled ? 'Enabled' : 'Disabled'}
      </span>
    </div>
  );
}
